"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POSITION = exports.DEFAULT_STYLES = exports.DEFAULT_DATA = exports.ALIGN = void 0;
const DEFAULT_STYLES = exports.DEFAULT_STYLES = {
  DEFAULT_BACKGROUND_COLOR: 'default',
  DEFAULT_TITLE_COLOR: 'neutral',
  DEFAULT_SUBTITLE_COLOR: 'greyDark',
  DEFAULT_MIN_HEIGHT: '100px',
  DEFAULT_MAX_WIDTH: '456px',
  DEFAULT_MIN_WIDTH_DESKTOP: '384px',
  DEFAULT_MIN_WIDTH: '100px'
};
const DEFAULT_DATA = exports.DEFAULT_DATA = {
  title: 'Login now for BIG Member discounts',
  description: 'Log into get BIG Member discounts and also redeem your unlimited pass',
  loginText: 'Login',
  signUpText: 'Signup'
};
const POSITION = exports.POSITION = {
  absolute: 'absolute',
  relative: 'relative'
};
const ALIGN = exports.ALIGN = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};